import { Tooltip } from 'antd'
import { PayItemConnectionGroup } from 'schema'
import { HelpMessage } from 'utils/constants'
import { CIMSSingleColumn } from 'components/CIMSTable/CIMSColumn/types'
import { alphabeticalCompare } from '@cims-online/shared'

export function useGroupColumn<
  T extends {
    group?: Pick<
      PayItemConnectionGroup,
      'id' | 'name' | 'description' | 'order'
    > | null
  }
>(): CIMSSingleColumn<T> {
  return {
    title: 'Group',
    help: HelpMessage.PayItems.Groups,
    render: ({ group }) => {
      if (!group) return null
      const { name, description } = group
      if (description) return <Tooltip title={description}>{name}</Tooltip>
      return name
    },
    sort: {
      with: 'callback',
      onCompare: (a, b) => alphabeticalCompare(a.group, b.group, 'order'),
    },
    filter: {
      type: 'search',
      with: 'callback',
      onFilter: (value, { group }) => {
        if (!group?.name) return false
        return group.name.toLowerCase().includes(value.toString().toLowerCase())
      },
    },
  }
}
